import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { UsuarioPermissaoEdicaoComponent } from './usuario-permissao-edicao/usuario-permissao-edicao.component';
import { UsuarioPermissaoRoutingModule } from './usuario-permissao.routing';
import { UsuarioPermissaoListaComponent } from './usuario-permissao-lista/usuario-permissao-lista.component';
import { UsuarioPermissaoService } from './usuario-permissao.service';
import { UsuarioPermissaoFrmComponent } from './usuario-permissao-frm/usuario-permissao-frm.component';

@NgModule({
  declarations: [UsuarioPermissaoEdicaoComponent, UsuarioPermissaoListaComponent, UsuarioPermissaoFrmComponent],
  imports: [
    AppSharedModule,
    UsuarioPermissaoRoutingModule
  ],
  exports: [
    UsuarioPermissaoRoutingModule
  ],
  providers: [
    UsuarioPermissaoService
  ]
})
export class UsuarioPermissaoModule { }
